import { StyleSheet, View } from 'react-native';
import { Text } from '../../../components/primitives/Text';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';
import { tokens } from '../../../theme/tokens';

interface MappingConfidenceBadgeProps {
  confidence: number;
}

function getConfidenceStyle(confidence: number) {
  if (confidence >= 0.8)
    return {
      key: 'high' as const,
      color: colors.status.success.main,
      bg: colors.status.success.bg,
    };
  if (confidence >= 0.5)
    return {
      key: 'medium' as const,
      color: colors.status.warning.main,
      bg: colors.status.warning.bg,
    };
  return { key: 'low' as const, color: colors.status.error.main, bg: colors.status.error.bg };
}

export function MappingConfidenceBadge({ confidence }: Readonly<MappingConfidenceBadgeProps>) {
  const { t } = useTranslation();
  const level = getConfidenceStyle(confidence);

  return (
    <View
      style={[styles.badge, { backgroundColor: level.bg }]}
      testID="mapping_confidence_badge"
      accessibilityLabel={t(`leadImport.confidence.${level.key}`)}
      accessibilityRole="text"
    >
      <Text variant="caption" style={{ color: level.color, fontSize: tokens.fontSize.xs }}>
        {t(`leadImport.confidence.${level.key}`)}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  badge: {
    paddingHorizontal: tokens.spacing.sm,
    paddingVertical: 2,
    borderRadius: tokens.radius.full,
  },
});
